<template>
  <div
    class="col pt-3 pl-2 mb-4 p-lg-4 profile-wrapper"
    style="background-color: #fff;"
  >
    <profile-header :userData="getUserData">
    </profile-header>
    <br>
    <div class="row">
      <div class="col">
        <h5 id="user-address-head"
												data-test="profileHeading">
          Personal Details
        </h5>
      </div>
      <div class="col-2">
        <button
          type="button"
          name
          class="btn btn-link float-right"
          v-if="!editUserInfo"
          @click.prevent="editUserInfo = !editUserInfo"
          id="user-address-edit-btn"
										data-test="profileEditBtn"
        >
          Edit
        </button>
      </div>
    </div>
    <hr>
				<personnal-details-form :userData="userData"
																												:editUserInfo="editUserInfo"
																												@cancelPersonnalData="cancelPersonnalData"
																												@personnalDataSubmit="updateUserData">
				</personnal-details-form>
    <div class="divider"></div>
    <hr>
    <div class="row">
      <div class="col">
        <h5 id="user-account-setting-head"
												data-test="profileAccountSettingHeading">
          Account Settings
        </h5>
      </div>
      <div class="col-2">
        <button
          type="button"
          class="btn btn-link float-right"
          v-if="!editPassword"
          @click.prevent="editPassword = !editPassword"
          id="user-account-setting-edit-btn"
										data-test="profileAccountSettingEditBtn"
        >
          Edit
        </button>
      </div>
    </div>
    <hr>
				<edit-password-form :passwordData="passwordData"
																								:editPassword="editPassword"
																								:currentPasswordError="currentPasswordError"
																								@cancelPasswordData="cancelPasswordData"
																								@passwordDataSubmit="updatePassword">
				</edit-password-form>
    <hr>
    <div class>
      <a
        href
        name
        class="float-left py-2 px-3"
        style="color: #c90a0a; text-decoration: snow"
        v-if="!editUserInfo"
        @click.prevent="deactivateAccount"
        id="user-deactivation-btn"
								data-test="profileDeactivateLink"
      >
        Deactivate Account
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { authenticationApi } from '@/services/ApiServices/authenticationApi'
import { customerApi } from '@/services/ApiServices/customerApi'
import ProfileHeader from './ProfileHeader'
import PersonnalDetailsForm from './Forms/personnalDetailsForm'
import EditPasswordForm from './Forms/EditPasswordForm'

export default {
	components: {
		EditPasswordForm,
		PersonnalDetailsForm,
		ProfileHeader },
	data () {
		return {
			i: 0,
			userData: {},
			userFormError: false,
			showPasswordFormErrors: false,
			editUserInfo: false,
			editAccountSettings: false,
			editPassword: false,
			currentPasswordError: '',
			passwordData: {
				currentPassword: '',
				newPassword: '',
				confirmPassword: ''
			},
			showBrowse: false,
			selectedFile: null,
			imageUrl: ''
		}
	},
	computed: {
		...mapGetters('user', ['getUserData'])
	},
	mounted () {
		this.userData = JSON.parse(JSON.stringify(this.getUserData))
		this.setUserData = JSON.parse(JSON.stringify(this.getUserData))
	},
	watch: {
		editPassword () {
			if (!this.editPassword) {
				// this.showPasswordFormErrors = false
				this.resetEditPasswordForm()
			}
		},
		editUserInfo () {
			if (!this.editUserInfo) {
				// this.userFormError = false
				this.userData = JSON.parse(JSON.stringify(this.getUserData))
			}
		},
		getUserData () {
			this.userData = JSON.parse(JSON.stringify(this.getUserData))
		}
	},
	methods: {
		// action (scope) {
		// 	this.$validator.validateAll(scope).then((result) => {
		// 		if (result) {
		// 			if (scope === 'editPasswordForm') {
		// 				this.showPasswordFormErrors = false
		// 				this.updatePassword(this.passwordData)
		// 			} else if (scope === 'personal-details') {
		// 				this.userFormError = false
		// 				this.updateUserData(this.userData)
		// 			}
		// 		} else if (scope === 'editPasswordForm') {
		// 			this.showPasswordFormErrors = true
		// 		} else if (scope === 'personal-details') {
		// 			this.userFormError = true
		// 		}
		// 	})
		// },
		deactivateAccount () {
			this.$dialog
				.confirm('Are you sure you want to deactivate your account?')
				.then((dialog) => {
					customerApi.accountDeactivation()
				})
				.catch(() => {
					// console.log('Clicked on cancel')
				})
		},
		resetEditPasswordForm () {
			this.currentPasswordError = ''
			this.passwordData = {
				currentPassword: '',
				newPassword: '',
				confirmPassword: ''
			}
			this.editPassword = false
		},
		updateUserData (userData) {
			let userDataChanged = false
			for (const key in this.setUserData) {
				if (this.setUserData[key] !== userData[key]) {
					userDataChanged = true
					break
				}
			}
			if (userDataChanged === true) {
				customerApi
					.updateCustomer(userData)
					.then(() => {
						this.$toasted.show('Profile Updated Successfully', {
							position: 'top-center'
						})
						this.editUserInfo = !this.editUserInfo
					})
					.catch((error) => {
						this.$toasted.show(` Message: ${error.body.message}`, {
							icon: 'exclamation-circle'
						})
					})
			} else {
				this.editUserInfo = !this.editUserInfo
				this.$toasted.show('No change found')
				// this.$emit('updateSuccess', this.user);
			}
		},
		cancelPersonnalData (editUserData) {
			this.editUserInfo = editUserData
		},
		cancelPasswordData (editPasswordData) {
			this.editPassword = editPasswordData
		},
		updatePassword (passwordData) {
			const newPasswordData = {
				old_password: passwordData.currentPassword,
				new_password: passwordData.newPassword,
				new_password_verify: passwordData.confirmPassword
			}
			authenticationApi
				.updatePassword(newPasswordData)
				.then(() => {
					this.$toasted.show('Password Updated Successfully', {
						position: 'top-center'
					})
					this.loginAfterReset(
						this.userData.email,
						this.passwordData.newPassword
					)
					this.resetEditPasswordForm()
				})
				.catch((error) => {
					this.$toasted.show(` Message: ${error.body.message}`, {
						icon: 'exclamation-circle'
					})
					// this.currentPasswordError = error.body.message ?
					// error.body.message :
					// error.body.status;
					this.currentPasswordError = error.body.status
				})
		},
		loginAfterReset (email, password) {
			this.loadLogin = authenticationApi
				.login(
					{
						username: email,
						password
					},
					'changePassword'
				)
				.then((res) => {
					if (res.status === 200) {
						this.$router.push('/')
					} else {

					}
				})
		}
	}
}
</script>
<style lang="scss">
</style>
